import { css } from '@emotion/core'

export const documentUploadPageWrapperCss = ({ mq, type }) => css`
  padding-bottom: var(--tri-space-300);
  height: 100%;

  .PopSheet-content {
    padding-top: 0;
  }

  .PopSheet-header-title {
    ${mq.xxSmallMaxWidth(type.triFontDesktopTitleSmallEmphasis)};
  }

  .PopSheet-header {
    ${mq.xxSmallMaxWidth({
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingBottom: '0',
    })};

    .PopSheet-header-actions {
      ${mq.xxSmallMaxWidth({ marginBottom: 'var(--tri-space-200)', width: 'auto' })};
      button {
        ${mq.xxSmallMaxWidth({ border: 'none', minHeight: '28px' })}
      }
    }
  }

  .top-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    ${mq.xxSmallMaxWidth({ position: 'relative' })}
  }

  .page-area {
    ${mq.xxSmallMaxWidth({ margin: '0 0 var(--tri-space-1300) 0' })}
  }

  .page-content {
    display: flex;
    flex-direction: column;
    gap: var(--tri-space-200);
    margin-top: var(--tri-space-600);
    ${mq.xxSmallMaxWidth({ marginTop: 'var(--tri-space-100)' })}
  }

  .main-title {
    ${type.triFontDesktopBodyLargeEmphasis}
    ${mq.xxSmallMaxWidth(type.triFontDesktopBodySmallEmphasis)}
  }
`
